module.exports = __webpack_public_path__ + "static/media/Primer_Mix_of_Primers_1_and_6.21bf2f18.svg";